import React, { Fragment } from "react";
import { lazyWithRetry } from "../../core/lazy_with_retry";
import { GeneralInformation } from "../template_offering_details_base";

import { TemplateOfferingDetailsMeetingRoom } from "../template_offering_details_meeting_room";
import { useTheMalinAnalytics } from "./themalin_analytics";
import { faqs, partnerConfig } from "./themalin_partner_config";

const Theme = lazyWithRetry(() => import("./themalin_theme"));

const generalInfo: GeneralInformation = {
  title: `General information`,
  description: "",
  bulletPoints: [
    {
      point: "Cancellation and changes",
      text: "Cancellations will be accepted up to 48 hours prior to the time of your booking.",
    },
    {
      point: "Access",
      text: "8:00 am to 8:00pm, Monday to Friday.",
    },
    {
      point: "Complimentary beverages",
      text: "Coffee, tea, and sparkling water.",
    },
  ],
};

export function OfferingTheMalinMeetingRoom() {
  useTheMalinAnalytics();

  return (
    <Fragment>
      <Theme />
      <TemplateOfferingDetailsMeetingRoom
        showAddress
        showDirections
        partnerConfig={partnerConfig}
        data={{
          faqs: faqs,
          generalInfo: generalInfo,
        }}
      />
    </Fragment>
  );
}
